<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Activating from your Account
                <p class='text-caption text-italic'>Applies to: {{ appliesToText }}</p>
            </div>
            <p>
                Generate your activation codes using your online account. This is the recommended method if you have had problems with the <router-link to='/support/help/software-activate'>automated activation feature</router-link> from your software, or if you have multiple software licenses saved in your account.
            </p>
            <p>
                If you need the setup file to install the software, go to the corresponding downloads page:
            </p>

            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/LoopCAD'>Download LoopCAD</router-link></li>
                <li><router-link to='/Download/HeatCAD'>Download HeatCAD</router-link></li>
                <li><router-link to='/Download/PlumbingCAD'>Download PlumbingCAD</router-link></li>
            </ul>

            <ol class='help-listStyle'>
                <li>
                    <p>
                        Sign into your online account by clicking <router-link to='/myaccount/licenses' target="_blank">here</router-link>. If you are already signed in, select <span class='text-weight-medium'>My Account</span>.
                    </p>
                    <p>
                        <img id='ActivateImg' class='img-fit' style="border: 1px solid lightgrey" :src="require('@/assets/img/help/NavigationBarAccountIcon.png')"
                             alt='Account Icon in the Navigation Bar' />
                    </p>
                </li>
                <li>
                    <p>Select the <span class="text-weight-medium">Licenses & Activations</span> category, then select the license that you want to activate.</p>
                    <p>
                        <img id='UpdateImg' class='img-fit' style="border: 1px solid lightgrey" :src="require('@/assets/img/help/LicensesAndActivationsBtn.png')"
                             alt='Licenses & Activations Button' />
                    </p>
                </li>
                <li>
                    <p>If you have a valid activation code already generated, you can simply copy it from here.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/LicensesAndActivationsTableRetrieveActivation.png')" /></p>
                </li>
                <li>
                    <p>If you need a new activation code, click the <span class="text-weight-medium">Actions</span> button, select <span class="text-weight-medium">Activate</span> from the drop down menu, then follow the prompts to generate the new Activation Code.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/LicensesAndActivationsTableGenerateActivation.png')" /></p>
                </li>
                <li>
                    <p>Enter and apply the Activation Code into the software on the corresponding computer.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/ActivationCodeField.jpg')" /></p>
                    <p>For help on entering new activation code, see the <router-link to='/Support/Help/Enter-Activation'>Entering an Activation Code</router-link> help topic.</p>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'account-activate',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>
